import React, { useState, forwardRef } from 'react';
import { useJsApiLoader } from '@react-google-maps/api';

import { Field } from '@tmap/mmm-style-guide/src/final-form/react';
import useDebounced from '@tmap/mmm-style-guide/src/useDebounced';
import { Search } from '@tmap/mmm-style-guide/src/Icon';
import { InputAdornment } from '@tmap/mmm-style-guide/src/Input';
import { Autocomplete } from '@tmap/mmm-style-guide/src/Autocomplete';
import { TextField } from '@tmap/mmm-style-guide/src/TextField';
import { Popper } from '@tmap/mmm-style-guide/src/Popper';

const GOOGLE_MAPS_API = {
  googleMapsApiKey: process.env.NEXT_PUBLIC_MAP_API_KEY,
  libraries: ['places'],
};

function PopperComponent(props, ref) {
  return (
    <Popper placement='top' {...props} ref={ref} />
  );
}

function AutocompleteField({ input, ...otherProps }) {
  return (
    <Autocomplete
      {...input}
      {...otherProps}
      renderInput={(params) => (
        <TextField
          {...params}
          InputProps={{
            ...params.InputProps,
            startAdornment: (<InputAdornment position='start' sx={{ padding: 0.5 }}><Search /></InputAdornment>),
          }}
        />
      )}
      PopperComponent={forwardRef(PopperComponent)}
      onChange={(e, v) => {
        if (v === null) {
          input.onChange();
        } else {
          input.onChange({
            description: v.description,
            placeId: v.place_id,
          });
        }
      }}
      onInputChange={(e, v) => {
        input.onChange({ description: v });
        otherProps.onInputChange(e, v);
      }}
    />
  );
}

export function LocationField({ handleInputChange, options }) {
  const fetch = useDebounced((value) => {
    handleInputChange(value);
  }, 300);
  return (
    <Field
      id='address-autocomplete'
      name='location'
      label='Address'
      type='text'
      options={options}
      getOptionLabel={(option) => option.description ?? option}
      component={AutocompleteField}
      freeSolo
      onInputChange={(e, newValue) => fetch(newValue)}
    />
  );
}

function LocationInput() {
  const { isLoaded } = useJsApiLoader(GOOGLE_MAPS_API); /* global google */
  const [options, setOptions] = useState([]);
  if (isLoaded) {
    const service = new google.maps.places.AutocompleteService();
    const handleInputChange = (value) => service.getPlacePredictions({
      input: value,
      componentRestrictions: { country: ['us'] },
    }, (results) => {
      if (results) {
        setOptions(results);
      } else {
        setOptions([]);
      }
    });
    return (
      <LocationField
        options={options}
        handleInputChange={handleInputChange}
      />
    );
  }
  return null;
}

export default LocationInput;
